import React, { useState } from "react";
import styled from 'styled-components'
import { MdArrowDropDown } from "react-icons/md";
import Sidepop from "../Pop/Sidepop";
export default function Dropdown({selected, setSelected}){
    const [openMode, setOpenMode] = useState(false);
    const [selectmenu, setSelect] = useState(false)
    // const option = ["Active", "Product"]
    return(
        <>
        <Div>
            <div className="dropdown">
                <div className="dropdown-btn" onClick={(e) => setSelect(!selectmenu)}>{selected} <MdArrowDropDown className={selectmenu ? "dropbtn" : null}/></div>
               {selectmenu && 
                <div className="dropdown-content">
{/* 
                    {option.map((option)=>(
                        <div
                        onClick={(e) =>{
                            setSelected(option)
                            setSelect(false)
                            setOpenMode(true);  
                        }
                    }
                        className="dropdown-items" >
                        {option }
                    </div>
                    ))}
                
                */}
                <div className="dropdown-items" onClick={() => {
                
                setSelect(false)
                setSelected("Active")
              }}>
                    Active
                </div>
                <div className="dropdown-items" onClick={() => {
                setOpenMode(true);
                setSelect(false)
                setSelected("Product")
              }}>Product</div>
            </div>
               }
            </div>

        </Div>
        {openMode && <Sidepop closeMode={setOpenMode} />}
        </>
    )
}
const Div = styled.div`
.dropdown{
    position: relative;
    user-select: none;
    .dropdown-btn{
        width: 100%;
    padding: 10px;
    border: none;
    outline: none;
    background-color: #26395c;
    border-radius: 8px;
    color: #697ea8;
    font-size: 16px;
    font-weight: 400;
    font-family: "MYRIADPRO-REGULAR";
    transition: all 0.5s;
    user-select: none;
    cursor: pointer;
    svg{
        float: right;
        font-size: 25px;
        transition: all 1s;
    }
    .dropbtn{
        transform: rotate(180deg);
        transition: all 1s;
    }
    }
    .dropdown-content{
        position: absolute;
        width: 100%;
        z-index: 12;
        padding: 10px;
        top: 47px;
    border: none;
    outline: none;
    background-color: #26395c;
    border-radius: 8px;
    color: #697ea8;
    font-size: 16px;
    font-weight: 400;
    font-family: "MYRIADPRO-REGULAR";
    transition: all 0.5s;
    user-select: none;
    cursor: pointer;
    }
}
`;
